module.exports = __webpack_public_path__ + "files/bb4cb9f8d481d0447be0177c8303884d.png";